import { currencyColumn, dateColumn, numberColumn, primaryRelationshipColumn, relationshipColumn, textColumn } from "@api/schema/columnHelpers";
import { objectDefinition } from "@api/schema/supportedObjects";
import RapidReinvestmentSection from "./RapidReinvestmentSection";
import { forwardRef } from "react";

const relationshipType = 'property';
const {pluralName, color, endpoint} = objectDefinition(relationshipType);
const columns = [
    dateColumn({column: 'volunteered_at', required: true}),
    numberColumn({column: 'hours', label: 'Hours', inputType: 'number', required: true}),
    relationshipColumn({column: 'contacts', label: 'Contacts', endpoint: 'contacts', multiple: true, hydrate: false}),
    relationshipColumn({column: 'involvement_id', label: 'Related Involvement', endpoint: 'involvements', groupBy: (option) => option.category_name, hydrate: false}),
    textColumn({column: 'notes', label: 'Notes',}),
];

const VolunteerHours = forwardRef(function VolunteerHours(props, ref) {
    return (
        <RapidReinvestmentSection
            type={relationshipType}
            columns={columns}
            {...props}
            ref={ref}
        />
    )
});

export {VolunteerHours};
